import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@material-ui/styles'
import { useMediaQuery } from '@material-ui/core'
import { Sidebar, Topbar } from './components'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}))

const MainModules = (props) => {
  const { children, type } = props

  const classes = useStyles()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  })

  const [openSidebar, setOpenSidebar] = useState(false)

  const sideOpen = useSelector((state) => state.sidebar.openSidebar);
  const [contentSize, setContentSize] = useState(sideOpen ? '240px' : '5%')

  const handleCollapse = (open) => {
    setContentSize(open ? '240px' : '5%')
  }

  const handleSidebarOpen = () => {
    setOpenSidebar(true)
  }

  const handleSidebarClose = () => {
    setOpenSidebar(false)
  }

  const shouldOpenSidebar = isDesktop ? true : openSidebar

  return (
    <div className={classes.root} style={{ paddingLeft: isDesktop ? contentSize : 0 }}>
      <Topbar
        onSidebarOpen={handleSidebarOpen}
        type={type}
      />

      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        isDesktop={isDesktop}
        type={type}
        onCollapse={handleCollapse}
      />

      <main className={classes.content}>
        {children}    
      </main>
    </div>
  )
}

MainModules.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string
}

export default MainModules
